import PropTypes from "prop-types"
import React, { useContext } from "react"
import styled from "styled-components"
import Header from "../components/header"
import SEO from "../components/seo"
import GlobalContextProvider, {
  GlobalStateContext,
} from "../context/GlobalContextProvider"
import "../styles/fonts.css"
import "../styles/reset.css"
import "../styles/base.css"
import vars from "../styles/vars"
import CookieConsent from "react-cookie-consent"

const StyledPagelayout = styled.div`
  padding-bottom: 40px;
  min-height: 100vh;

  background-color: ${({ lightMode }) =>
    lightMode ? vars.colors.grayLight : vars.colors.grayDark};
  color: ${({ lightMode }) =>
    lightMode ? vars.colors.grayDark : vars.colors.grayLight};

  @media ${vars.mq.desktop.query} {
    height: 100vh;
    padding-bottom: 0;
    overflow: hidden;
  }
`

const Container = styled.div`
  margin: 0 auto;
  max-width: 1790px;
  padding-left: 16px;
  padding-right: 16px;

  @media ${vars.mq.tablet.query} {
    padding-left: 32px;
    padding-right: 32px;
  }

  @media ${vars.mq.desktop.query} {
    height: 100%;
  }

  @media ${vars.mq.desktopLarge.query} {
    padding-left: 64px;
    padding-right: 64px;
  }
`

const Main = styled.main`
  padding-top: ${({ isStatic }) => (isStatic ? "150px" : "130px")};
  position: relative;

  @media ${vars.mq.desktop.query} {
    padding-top: 0;
    height: 100%;
  }
`

const Layout = ({ children, isStatic }) => {
  return (
    <GlobalContextProvider>
      <CookieConsent
        location="bottom"
        enableDeclineButton
        buttonText="Cookies akzeptieren"
        declineButtonText="Cookies ablehnen"
        onAccept={() => {
          if (window._paq) {
            window._paq.push(["setConsentGiven"])
            window._paq.push(["setCookieConsentGiven"])
          }
        }}
        style={{
          fontSize: "0.75em",
          alignItems: "center",
        }}
        buttonStyle={{
          backgroundColor: vars.colors.primary,
          padding: "1em",
          margin: "10px",
        }}
        declineButtonStyle={{
          backgroundColor: "transparent",
          padding: "1em",
          margin: "10px",
        }}
        contentStyle={{
          margin: "10px",
        }}
      >
        Auch wir setzen Cookies ein, um den Benutzerkomfort für Sie auf unserer
        Website zu verbessern und die Sichtbarkeit unseres nachhaltigen
        Bankgeschäftes im Netz zu erhöhen. Wir gehen vertrauenswürdig mit
        Cookies um, verstehen aber auch, wenn Sie nicht getrackt werden möchten.{" "}
        <a
          href="https://www.gls.de/privatkunden/datenschutz/"
          style={{ color: vars.colors.primary }}
          target="_blank"
          rel="noreferrer"
        >
          Datenschutzerklärung
        </a>
      </CookieConsent>
      <SEO />
      <Pagelayout isStatic={isStatic}>{children}</Pagelayout>
    </GlobalContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const Pagelayout = ({ children, isStatic }) => {
  const { lightMode } = useContext(GlobalStateContext)
  return (
    <>
      <StyledPagelayout lightMode={lightMode}>
        <Container>
          <Header />
          <Main isStatic={isStatic}>{children}</Main>
        </Container>
      </StyledPagelayout>
    </>
  )
}
